import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container view-wrapper has-text-center justify-content-center mt-5 p-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://img.freepik.com/free-vector/maintenance-concept-illustration_114360-381.jpg",
  height: "300",
  width: "300"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "p-2 sz-80 adlam-display-regular is-size-1-mobile" }, "Not Found Page", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Sorry your page request is not found, please back to previous page :)", -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { unref } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFound',
  setup(__props) {

const router = useRouter();
const { path } = unref(router.currentRoute);

if (path !== '/404') {
  router.replace({ path: '/404' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_5))
}
}

})